module.exports = __webpack_public_path__ + "static/media/prescription-preview.4a468d04.jpg";